export default "/public/app-main/static/image/e9284a29de70fc90c2b13ba7fb78eca5.png";